var Backbone = require('backbone');
var _ = require('underscore/underscore');

var Base = require('front/components/Base/Base');
var SendButton = require('front/components/SendButton/SendButton');

require('./IndexFinders.less');

module.exports = Base.extend({
    template: require('./IndexFinders.jinja'),

    el: '.IndexFinders',

    events: {
        'click .SendButton': 'onSubmit',
        'input .IndexFinders-phone': 'onChange'
    },

    initialize: function (options) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, 'setTomorrow');

        this.$btn = this.$('.SendButton');
        this.$phone = this.$('.IndexFinders-phone');

        this.setTomorrow();
        this.onChange();
    },

    viewsRegistration: function () {
        this.registerView('sendButton', new SendButton({
            el: this.$('.SendButton')
        }));
    },

    setTomorrow: function () {
        var time = window.app.data.time;
        var nowTime = new Date(time);
        var $text = this.$('.IndexFinders-text span');
        var minTime = new Date();
        var maxTime = new Date();

        minTime.setHours(0,0,0);
        maxTime.setHours(17,0,0);

        if (nowTime < maxTime && nowTime > minTime) {
            $text.html('сегодня');
        } else {
            $text.html('завтра');
        }
    },

    onSubmit: function (e) {
        var phone = this.$phone.val();
        var data = {
            phone: phone,
            theme: 'Вакансия'
        };
        var sendButton = this.getView('sendButton');

        sendButton.submit(data);
    },

    onChange: function () {
        this.$btn.prop('disabled', !this.$phone.val());
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexFinders/IndexFinders.js
// module id = 51
// module chunks = 0